<template>
    <b-row class="h-100 align-items-center">
        <b-col sm="6" offset-sm="3" class="mx-auto text-center">
            <i class="fa-solid fa-spinner fa-spin-pulse fa-sm me-1 text-primary"></i>
            <span class="h6">Carregando dados...</span>
        </b-col>
    </b-row>
</template>
<script setup>
</script>
